export const iconFontAwesomeEducationGraduationCap = (
	<i className="fa-solid fa-graduation-cap"></i>
);
